export class ConsultantRateModel {
  Client!: string;
  Project!: string;
  Rate!: string;
  Currency_symbol_short!: string;
  Currency_Code!: string;
  Currency_To!: string;
  Converted_Currency_Symbol!: string;
  Converted_Currency_Code!: string;
  Converted_Rate!: string;
  Is_Converted_Rate!: number;
  Is_Default_Rate!: number;
  Display_Rate!: string;
  Is_Project_Country_Base?: number;   // 1 = the base rate row that matches the project's country
  Project_Rate?: string;
  Project_Rate_key?: string;
}

export class ConsultantProjectRateParameterModel {
  employee!: string;
  client!: string;
  project!: string;
  entrydate!: string;
  hourlyRate?: number;
  leveragePercentage?: number;
  currencyCode?: string;
}
